import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";

import { UniversityAction } from "../../store/actions";

import { Buttons, Modal } from "..";

const UploadUni = ({ text = "Upload", width = "8em" }) => {
  const dispatch = useDispatch();
  const fileSelectRefs = useRef({});

  const { isAddLoading } = useSelector((state) => state?.university);

  const [modalVisible, setModalVisible] = useState(false);

  const sheetNames = [
    { label: "General", value: "general" },
    { label: "Programs", value: "programs" },
    { label: "Application Journey", value: "applicationJourney" },
    { label: "Finance", value: "finance" },
    { label: "Scholarships", value: "scholarships" },
    { label: "Subject Ranking", value: "subjectRanking" },
  ];

  const handleUpload = (file, sheet) => {
    const formdata = new FormData();
    formdata.append("page", sheet);
    formdata.append("file", file);

    const key = "uploadMessage";
    message.loading({
      content: "Data is being updated in the backend",
      key,
      duration: 0,
    });

    dispatch(
      UniversityAction.addUniversitySheet(formdata, (res) => {
        if (res.status === 200) {
          message.success({
            content: "Data updated successfully",
            key,
            duration: 2,
          });
        }
      })
    );
    setModalVisible(false);

    // Reset file input value to allow re-uploading the same file
    if (fileSelectRefs.current[sheet]) {
      fileSelectRefs.current[sheet].value = "";
    }
  };

  return (
    <div className={`${width}`}>
      <Buttons.DefaultButton
        size="medium"
        width="full"
        onClick={() => setModalVisible(true)}
        disabled={isAddLoading}
      >
        {text}
      </Buttons.DefaultButton>
      <Modal.DefaultModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
      >
        <div className="w-[35em] flex flex-col gap-4 justify-center items-center">
          <div className="text-main font-bold text-[2em]">
            Upload University Sheet
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {sheetNames.map((item, index) => (
              <div key={index}>
                <Buttons.DefaultButton
                  size="medium"
                  width="max"
                  onClick={() => fileSelectRefs.current[item.value]?.click()}
                  disabled={isAddLoading}
                >
                  {item.label}
                </Buttons.DefaultButton>
                <input
                  type="file"
                  style={{ display: "none" }}
                  accept=".xlsx"
                  ref={(el) => (fileSelectRefs.current[item.value] = el)}
                  onChange={(event) => {
                    if (event.target.files.length > 0) {
                      handleUpload(event.target.files[0], item.value);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default UploadUni;
